module.exports = __webpack_public_path__ + "static/images/00b6b0f86c7f8b66256104e319995fb3.webp";